import { useFormik } from 'formik';
import React, { useEffect } from "react";
import toast from 'react-hot-toast';
import { Form } from "reactstrap";
import { InputField } from 'src/components';
import { useCreateByPostMutation } from 'src/rtk/features/common/crudApi';
import loader from '../../../assets/images/loader.gif';
import * as thesisMarksheetUrl from 'src/helpers/url_helper';

const instruction = [
    {
        id: 1,
        text: "Objective's of Thesis in FCPS course?",
        child: [
            {
                text: "To conduct research work as thesis"
            },
            {
                text: "To develop skill of retrieving research publication"
            },
            {
                text: "To utilize research finding intheir daily practice life"
            },
            {
                text: "To transfer evidence based practice in clinical settings"
            },
            {
                text: "To write a scientific researcch paper"
            },
        ]
    },
    {
        id: 2,
        text: "Scoring/grading/marking method?",
        child: [
            {
                text: "At present a thesis work and submission before speculated time is mandatory"
            },
            {
                text: "Successful defence of it is a pre-requisite to appear in the FCPS (Final) examination"
            },
            {
                text: "Marks as grades are given both for writing and thesis defence but those are transformed into 'eligibility' only"
            },
            {
                text: "Grade obtained are not in the final mark sheet , not even the successful completion of the thesis defence"
            },
        ]
    }
];

const assesmentSystem = [
    { id: 1, text: "a) Did the candidate confirm to the accepted protocol?" },
    { id: 2, text: "Did she mention deviations?", option: "accepted_protocol_mentioned_deviation", comments: "accepted_protocol_mentioned_deviation_comments" },
    { id: 3, text: "Did she justify deviations?", option: "accepted_protocol_justified_deviation", comments: "accepted_protocol_justified_deviation_comments" },
    { id: 4, text: "Are her justifications acceptable?", option: "accepted_protocol_justification_acceptable", comments: "accepted_protocol_justification_acceptable_comments" },

    { id: 5, text: "b) Methods- (Followed/not followed)" },
    { id: 6, text: "Deviated - (minor)", option: "methods_minor_deviated", comments: "methods_minor_deviated_comments" },
    { id: 7, text: "Deviated - (major Justified/not Justified)", option: "methods_major_deviated", comments: "methods_major_deviated_comments" },

    { id: 8, text: "c) Results as per protocol" },
    { id: 9, text: "Results used appropriately", option: "results_used_appropriately", comments: "results_used_appropriately_comments" },
    { id: 10, text: "Interpretation done appropriately", option: "interpretation_done_appropriately", comments: "interpretation_done_appropriately_comments" },
    { id: 11, text: "Statistics used appropriately", option: "statistics_used_appropriately", comments: "statistics_used_appropriately_comments" },
    { id: 12, text: "Tables used appropriately", option: "tables_used_appropriately", comments: "tables_used_appropriately_comments" },
    { id: 13, text: "Figures used appropriately", option: "figures_used_appropriately", comments: "figures_used_appropriately_comments" },

    { id: 14, text: "d) Discussion done sequentially" },
    { id: 15, text: "Responded to all the identified, main outcome variables", option: "responded_to_identified_outcome_variables", comments: "responded_to_identified_outcome_variables_comments" },
    { id: 16, text: "Used recent publications, (80% less than 5 years)", option: "used_recent_publications", comments: "used_recent_publications_comments" },
    { id: 17, text: "Compared and contrasted with published information", option: "compared_and_contrast_with_published_information", comments: "compared_and_contrast_with_published_information_comments" },
    { id: 18, text: "Justified the variation or confirmation", option: "justified_the_variation_or_conformation", comments: "justified_the_variation_or_conformation_comments" },
    { id: 19, text: "Conclusion justified", option: "conclusion_justified", comments: "conclusion_justified_comments" },
    { id: 20, text: "Any generalization", option: "any_generalization", comments: "any_generalization_comments" },
    { id: 21, text: "Limitation of the study (identified)", option: "limitation_of_study", comments: "limitation_of_study_comments" },

    { id: 22, text: "e) References- (conform to guideline)", option: "references", comments: "references_comments" },
];

export const ThesisMarkingModal = (props: any) => {
    const { toggleModal, viewData } = props;

    const [createThesisMarking, { isSuccess, isLoading, isError, error }] = useCreateByPostMutation();

    // Create initial values dynamically from assesmentSystem
    const getInitialValues = () => {
        const initialValues: any = {};
        assesmentSystem.forEach((item) => {
            if (item.option) {
                initialValues[item.option] = null; // null for unselected boolean
            }
            if (item.comments) {
                initialValues[item.comments] = '';
            }
        });
        // Add result grade field
        initialValues.thesis_writing_mark = null;
        initialValues.thesis_marking_comment = '';
        initialValues.thesis_file_id = '';
        return initialValues;
    };

    const formik = useFormik({
        initialValues: getInitialValues(),

        onSubmit: (values) => {
            values.thesis_file_id = viewData.id;
            console.log('Form submitted with values:', values);
            let postData = {
                queryUrl: thesisMarksheetUrl.THESIS_MARKING_BY_EXAMINER,
                formData: values,
            };
            createThesisMarking(postData);
        },
    });

    const {
        handleSubmit,
        values,
        setFieldValue,
        getFieldProps,
    } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success('Thesis marking submitted successfully!');
            toggleModal();
        } else if (isError) {
            toast.error('Failed to submit thesis marking. Please try again.');
        }
    }, [isSuccess, isError]);

    console.log(values.thesis_writing_mark);
    return (
        <div>
            {isLoading ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Form onSubmit={handleSubmit}>
                <div className="bg-light bg-opacity-50">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Thesis Marking</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggleModal}></button>
                    </div>
                    <div className="modal-body">
                        {
                            instruction.map((item) => (
                                <div key={item.id} className="mb-3">
                                    <h6>{item.id}. {item.text}</h6>
                                    {
                                        item.child && item.child.length > 0 && (
                                            <ul>
                                                {item.child.map((childItem, index) => (
                                                    <li key={index}>{childItem.text}</li>
                                                ))}
                                            </ul>
                                        )
                                    }
                                </div>
                            ))
                        }
                        <h6>3. Assessment System of thesis defence</h6>

                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="card shadow-lg">
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table table-bordered mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="fw-bold text-center" style={{ width: '50%' }}>Points</th>
                                                        <th className="text-center fw-bold" style={{ width: '25%' }}>
                                                            Select Option
                                                            <div className="row g-0 mt-2">
                                                                <div className="col-6 border-end">
                                                                    <small className="fw-semibold">Yes</small>
                                                                </div>
                                                                <div className="col-6">
                                                                    <small className="fw-semibold">No</small>
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th className="text-center fw-bold" style={{ width: '25%' }}>Comment</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {assesmentSystem.map((section) => (
                                                        <React.Fragment key={section.id}>
                                                            <tr className="table-secondary">
                                                                <td className={`${[1, 5, 8, 14, 22].includes(section.id) ? 'fw-bold' : 'ps-4'} p-2`}>
                                                                    {section.text}
                                                                </td>
                                                                {
                                                                    [1, 5, 8, 14].includes(section.id) ? (
                                                                        <td colSpan={2}></td>
                                                                    ) : (
                                                                        <>
                                                                            <td className="text-center align-middle">
                                                                                <div className="row g-0">
                                                                                    <div className="col-6 border-end">
                                                                                        <div className="form-check d-flex justify-content-center">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name={section.option}
                                                                                                value="true"
                                                                                                id={`main-${section.id}-yes`}
                                                                                                checked={values[section.option!] === true}
                                                                                                onChange={() => setFieldValue(section.option!, true)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-6">
                                                                                        <div className="form-check d-flex justify-content-center">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name={section.option}
                                                                                                value="false"
                                                                                                id={`main-${section.id}-no`}
                                                                                                checked={values[section.option!] === false}
                                                                                                onChange={() => setFieldValue(section.option!, false)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="p-2">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    placeholder="Enter comment..."
                                                                                    name={section.comments}
                                                                                    value={values[section.comments!] || ''}
                                                                                    onChange={(e) => setFieldValue(section.comments!, e.target.value)}
                                                                                />
                                                                            </td>
                                                                        </>
                                                                    )
                                                                }
                                                            </tr>
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h6>4. Declaration of Results: (By individual examiner)</h6>

                        <div className="row justify-content-center mt-3">
                            <div className="col-12">
                                <div className="card shadow-lg">
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table table-bordered mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="fw-bold text-center" rowSpan={2} style={{ width: '40%', verticalAlign: 'middle' }}>
                                                            Name of Candidate & Specialty
                                                        </th>
                                                        <th className="fw-bold text-center" style={{ width: '40%' }}></th>
                                                        <th className="fw-bold text-center" style={{ width: '10%' }}>Grade</th>
                                                        <th className="fw-bold text-center" style={{ width: '10%' }}>Select</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-bold text-center align-middle" rowSpan={7}>
                                                            {viewData?.trainee_name}
                                                            <br />
                                                            <span className="fw-semibold">{viewData?.subject_name}</span>
                                                        </td>
                                                        <td className={`p-2 ${values.thesis_writing_mark === '18' ? 'bg-success' : ''}`}>Excellent</td>
                                                        <td className={`text-center align-middle ${values.thesis_writing_mark === '18' ? 'bg-success' : ''}`}>18</td>
                                                        <td className="text-center align-middle" rowSpan={7}>
                                                            <InputField
                                                                type="select"
                                                                {...getFieldProps('thesis_writing_mark')}
                                                                options={[
                                                                    { value: 18, label: '18' },
                                                                    { value: 17, label: '17' },
                                                                    { value: 16, label: '16' },
                                                                    { value: 15, label: '15' },
                                                                    { value: 14, label: '14' },
                                                                    { value: 13, label: '13' },
                                                                    { value: 12, label: '12' },
                                                                    { value: 11, label: '11' },
                                                                    { value: 10, label: '10' },
                                                                    { value: 9, label: '9' },
                                                                    { value: 8, label: '8' },
                                                                    { value: 7, label: '7' },
                                                                    { value: 6, label: '6' },
                                                                    { value: 5, label: '5' },
                                                                    { value: 4, label: '4' },
                                                                    { value: 3, label: '3' },
                                                                    { value: 2, label: '2' },
                                                                    { value: 1, label: '1' },
                                                                    { value: 0, label: '0' },
                                                                ]}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className={`p-2 ${values.thesis_writing_mark === '17' ? 'bg-success' : ''}`}>Very Good</td>
                                                        <td className={`text-center align-middle ${values.thesis_writing_mark === '17' ? 'bg-success' : ''}`}>17</td>

                                                    </tr>
                                                    <tr>
                                                        <td className={`p-2 ${values.thesis_writing_mark === '16' ? 'bg-success' : ''}`}>Good</td>
                                                        <td className={`text-center align-middle ${values.thesis_writing_mark === '16' ? 'bg-success' : ''}`}>16</td>

                                                    </tr>
                                                    <tr>
                                                        <td className={`p-2 ${values.thesis_writing_mark === '15' ? 'bg-success' : ''}`}>
                                                            Acceptable with minor Correction<br />
                                                            <small className="text-muted">
                                                                (Typographical, graphics, minimal changes in graph, table and discussion)
                                                            </small>
                                                        </td>
                                                        <td className={`text-center align-middle ${values.thesis_writing_mark === '15' ? 'bg-success' : ''}`}>15</td>

                                                    </tr>
                                                    <tr>
                                                        <td className={`p-2 ${values.thesis_writing_mark === '14' ? 'bg-success' : ''}`}>
                                                            Acceptable with major Correction<br />
                                                            <small className="text-muted">
                                                                (Re-analysis of segment, inclusion or exclusion of new graph, table, statistical analysis, overall changes and discussion etc.)
                                                            </small>
                                                        </td>
                                                        <td className={`text-center align-middle ${values.thesis_writing_mark === '14' ? 'bg-success' : ''}`}>14</td>

                                                    </tr>
                                                    <tr>
                                                        <td className={`p-2 ${(parseInt(values.thesis_writing_mark) <= 13 && parseInt(values.thesis_writing_mark) >= 0 && parseInt(values.thesis_writing_mark) !== null) ? 'bg-danger' : ''}`}>
                                                            Not acceptable (any correction that cannot be done within the stipulated time- re-collection of data needed to follow the methodology and complete the results as per protocol)
                                                        </td>
                                                        <td className={`text-center align-middle ${(parseInt(values.thesis_writing_mark) <= 13 && parseInt(values.thesis_writing_mark) >= 0 && parseInt(values.thesis_writing_mark) !== null) ? 'bg-danger' : ''}`}>13 or less than 13</td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="">Instruction For Examinee</label>
                            <div>
                                <InputField
                                    type="text"
                                    {...getFieldProps('thesis_marking_comment')}
                                />
                            </div>
                        </div>

                        <div className="mt-3 d-flex justify-content-center">
                            <button type="submit" className="btn btn-success w-25" disabled={isLoading}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}